import script from "./Success.vue?vue&type=script&setup=true&lang=ts"
export * from "./Success.vue?vue&type=script&setup=true&lang=ts"

import "./Success.vue?vue&type=style&index=0&id=557256ba&lang=scss"

const __exports__ = script;

export default __exports__